import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { GamesProvider } from "./context/GamesContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Roster from "./pages/Roster";
import PlayerProfile from "./pages/PlayerProfile";
import Tournaments from "./pages/Tournaments";
import TournamentDetail from "./pages/TournamentDetail";
import LiveStream from "./pages/LiveStream";
import Media from "./pages/Media";
import Sponsors from "./pages/Sponsors";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import LegalPage from "./pages/LegalPage";
import Recruitment from "./pages/Recruitment";
import About from "./pages/About";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function Shell({ children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-4rem)]">{children}</main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <GamesProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/roster" element={<Shell><Roster /></Shell>} />
            <Route path="/roster/:id" element={<Shell><PlayerProfile /></Shell>} />
            <Route path="/tournaments" element={<Shell><Tournaments /></Shell>} />
            <Route path="/tournaments/:id" element={<Shell><TournamentDetail /></Shell>} />
            <Route path="/live" element={<Shell><LiveStream /></Shell>} />
            <Route path="/media" element={<Shell><Media /></Shell>} />
            <Route path="/sponsors" element={<Shell><Sponsors /></Shell>} />
            <Route path="/contact" element={<Shell><Contact /></Shell>} />
            <Route path="/faq" element={<Shell><Faq /></Shell>} />
            <Route path="/terms" element={<Shell><LegalPage kind="terms" /></Shell>} />
            <Route path="/privacy" element={<Shell><LegalPage kind="privacy" /></Shell>} />
            <Route path="/recruitment" element={<Shell><Recruitment /></Shell>} />
            <Route path="/about" element={<Shell><About /></Shell>} />
            <Route path="/news" element={<Shell><News /></Shell>} />
            <Route path="/news/:slug" element={<Shell><NewsDetail /></Shell>} />
            <Route path="/admin/login" element={<Shell><AdminLogin /></Shell>} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Shell><AdminDashboard /></Shell>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        </GamesProvider>
      </AuthProvider>
    </div>
  );
}
